<template>
  <ul>
    <li
      class="nt-dropdown"
      :class="{ 'nt-dropdown--open' : inFocus }"
    >
      <a
        id="x"
        href="#"
        role="button"
        :aria-expanded="inFocus"
        aria-haspopup="true"
        title="Link"
        @focus="onFocus"
        @keydown="onKeyDown"
        @blur="onBlur"
      >Link</a>
      <ul
        role="menu"
        aria-labelledby="x"
      >
        <li class="language">
          <a
            ref="menuitem"
            href="/"
            title="SubLink"
            role="menuitem"
            @mousedown.prevent="onClick"
          >SubLink</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'nt-dropdown',
  data() {
    return {
      current: 0,
      inFocus: false
    }
  },
  methods: {
    onKeyDown(e) {
      e.preventDefault()
      e.stopPropagation()

      e = e || window.event
    },
    onFocus() {
      this.inFocus = true
    },
    onBlur() {
      this.inFocus = false
    },
    onClick() {
      // return
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    padding: 0;
    li {
      display: block;
      list-style: none;
      position: relative;
      & a {
        display: inline-block;
      }
      & ul {
        position: absolute
      }
    }
  }

  .nt-dropdown {
    border: 1px solid red;

    & ul {
      visibility: hidden;
    }

    &--open {
      & ul {
        visibility: visible;
      }
    }
  }
</style>
